import React, { useMemo } from 'react';

// utilities
import { MarkerShapesStandard } from '@fluke/irviewer/enums';

// components
import { Checkbox, List, ListItem, ListItemText } from '@common-ui/ui';
import { AutoGraph } from '@mui/icons-material';
import ButtonPopover from './ButtonPopover';

export default function StandardMarkers({ selected = [], onChange = null }) {
  const handleOnChange = (value, event) => {
    const isChecked = event?.target?.checked;
    let updatedOptions = [];

    if (isChecked) {
      updatedOptions = [...selected, value];
    } else {
      updatedOptions = selected.filter((option) => option !== value);
    }

    onChange?.({ standardMarkers: updatedOptions });
  };

  const checkBoxItems = useMemo(() => Object.keys(MarkerShapesStandard), []);

  return (
    <ButtonPopover label="Standard" tooltip={'Standard Markers'} Icon={<AutoGraph />}>
      <List>
        {checkBoxItems.map((key) => (
          <ListItem key={`checkbox-${key}`} dense>
            <Checkbox
              size="small"
              checked={selected.includes(key)}
              onChange={(event) => handleOnChange(key, event)}
            />

            <ListItemText>{key}</ListItemText>
          </ListItem>
        ))}
      </List>
    </ButtonPopover>
  );
}
